// extracted by mini-css-extract-plugin
module.exports = {"author":"Author_author__dbO_5","avatar":"Author_avatar__Ng9Ti","name":"Author_name__wdicS","posted":"Author_posted__WDD2u"};